/**
 * RoleBadge — shows the user's primary role next to the FitFrik wordmark on
 * Home. Colour + icon are picked from the `primary` role returned by
 * `GET /api/me/roles`.
 *
 * Every logged-in user is at least a Member, so this component always
 * renders something meaningful.
 */
import { Award, Dumbbell, Apple, Store, ShieldCheck, Crown, Sparkles } from "lucide-react";

const CONFIG = {
  member:       { label: "Member",      bg: "rgba(15,181,166,0.14)",  fg: "#0FB5A6", Icon: Sparkles },
  trainer:      { label: "Trainer",     bg: "rgba(0,212,255,0.16)",   fg: "#00B0D5", Icon: Dumbbell },
  nutritionist: { label: "Nutritionist",bg: "rgba(139,123,232,0.16)", fg: "#7A67D5", Icon: Apple },
  gym_owner:    { label: "Gym Owner",   bg: "rgba(245,197,24,0.18)",  fg: "#B58A00", Icon: Award },
  vendor:       { label: "Vendor",      bg: "rgba(255,120,73,0.16)",  fg: "#D85825", Icon: Store },
  admin:        { label: "Admin",       bg: "rgba(26,26,26,0.08)",    fg: "#1A1A1A", Icon: ShieldCheck },
  superadmin:   { label: "Super Admin", bg: "rgba(229,72,77,0.12)",   fg: "#E5484D", Icon: Crown },
};

export default function RoleBadge({ role = "member", size = "sm" }) {
  const cfg = CONFIG[role] || CONFIG.member;
  const px = size === "sm" ? { padding: "4px 10px", fontSize: 11, iconSize: 12, gap: 4 } : { padding: "6px 12px", fontSize: 13, iconSize: 14, gap: 5 };
  return (
    <span
      data-testid={`role-badge-${role}`}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: px.gap,
        padding: px.padding,
        borderRadius: 100,
        background: cfg.bg,
        color: cfg.fg,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontWeight: 700,
        fontSize: px.fontSize,
        lineHeight: 1,
        letterSpacing: "0.02em",
      }}
    >
      <cfg.Icon size={px.iconSize} />
      {cfg.label}
    </span>
  );
}
